

export const sharedStyles = {
  // Estilos do Dialog
  dialog: {
    '& .MuiDialog-backdrop': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)'
    }
  },
  dialogPaper: {
    height: '500px',
    position: 'relative',
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1a1a1a' : '#ffffff'
  },
  dialogTitle: {
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
    borderBottom: 1,
    borderColor: 'divider',
    padding: 2,
    position: 'sticky',
    top: 0,
    zIndex: 1,
    fontSize: '1.25rem',
    fontWeight: 500,
    color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#000'
  },
  dialogContent: {
    height: 'calc(100% - 140px)',
    overflow: 'auto',
    padding: 2,
    '&.MuiDialogContent-root': {
      paddingTop: 2
    },
    position: 'relative',
    top: 0,
    marginBottom: '60px',
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1a1a1a' : '#ffffff',
    '& .MuiTypography-root': {
      fontSize: '0.875rem',
      color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#000'
    },
    '& .MuiTabs-root': {
      borderBottom: 1,
      borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'
    },
    '& .MuiTab-root': {
      fontSize: '0.875rem',
      textTransform: 'none',
      minWidth: 120,
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
      '&.Mui-selected': {
        color: (theme) => theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2'
      }
    }
  },
  dialogActions: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    padding: 2,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
    borderTop: 1,
    borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)',
    zIndex: 1,
    height: '60px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  // Estilos dos campos de formulário
  formField: {
    '& .MuiInputBase-root': {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
      borderRadius: 1,
      '&.Mui-disabled': {
        backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'
      }
    },
    '& .MuiInputBase-input': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
      '&.Mui-disabled': {
        WebkitTextFillColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
        opacity: 0.7
      }
    },
    '& .MuiInputLabel-root': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
      '&.Mui-disabled': {
        color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
        opacity: 0.7
      }
    },
    '& .MuiSelect-icon': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)'
    },
    '& .MuiFormControlLabel-label': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)'
    },
    '& .MuiCheckbox-root': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)',
      '&.Mui-checked': {
        color: (theme) => theme.palette.mode === 'dark' ? '#90caf9' : '#1976d2'
      }
    }
  },

  // Estilos dos botões
  button: {
    height: '36px',
    textTransform: 'none',
    fontWeight: 500
  },
  outlinedButton: {
    color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#000',
    borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)',
    '&:hover': {
      borderColor: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#000',
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)'
    },
    '&.Mui-disabled': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.26)',
      borderColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.12)'
    }
  },
  containedButton: {
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#2E7D32',
    color: '#fff',
    '&:hover': {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#2E7D32' : '#1B5E20'
    }
  },

  // Estilos da tabela
  table: {
    '& .MuiTableHead-root': {
      backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)'
    },
    '& .MuiTableCell-head': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
      fontWeight: 600
    },
    '& .MuiTableCell-body': {
      color: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.4)'
    }
  },

  // Estilos dos filtros
  filterBox: {
    display: 'flex',
    gap: 2,
    marginBottom: 2,
    padding: 2,
    backgroundColor: (theme) => theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.05)',
    borderRadius: 1
  }
}; 